import FormHelperText from '@material-ui/core/FormHelperText'
import { withStyles } from '@material-ui/core/styles'

const BccFormHelperText = withStyles({
  root: {
    color: '#5b5b5b',
  },
})(FormHelperText)

export default BccFormHelperText
